import { render, staticRenderFns } from "./StaticPageModal.vue?vue&type=template&id=1d644166&"
import script from "./StaticPageModal.vue?vue&type=script&lang=js&"
export * from "./StaticPageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports